import * as React from "react";
import { Grid } from "@mui/material";
import { Link } from "react-router-dom";

interface Props {
  selectedPatients: any;
  pendingAdd: any;
  pendingRemoval: any;
  onList: any;
  handleCreate: Function;
  mode?: "transfer" | "unassign";
}

const PendingActionWidget: React.FC<Props> = (props: any) => {
  const isTransfer = props.mode === "transfer";
  const isUnassign = props.mode === "unassign";
  const showPending = isTransfer
    ? props.selectedPatients.length > 0
    : isUnassign
    ? props.selectedPatients.length > 0
    : props.pendingRemoval.length > 0 ||
      props.onList.length > 0 ||
      props.pendingAdd.length > 0;

  return (
    <Grid item xs={6} className="button-container">
      {showPending && (
        <div
          className="pending-add-create-widget"
          style={{
            maxWidth: 385,
            width: "75%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 25,
            }}
          >
            {isTransfer ? (
              <div className="pending-add">
                <span className="badge">{props.selectedPatients.length}</span>
                <span className="pending-add-text">Pending Transfer</span>
              </div>
            ) : isUnassign ? (
              <div className="pending-removal">
                <span className="badge">{props.selectedPatients.length}</span>
                <span className="pending-removal-text">Pending Unassign</span>
              </div>
            ) : null}
          </div>

          <button className="widget-button" onClick={props.handleCreate}>
            {isTransfer ? "Transfer" : isUnassign ? "Unassign" : "Create"}
          </button>
        </div>
      )}

      <Link
        style={{
          display: "inline-block",
          cursor: "pointer",
          paddingRight: 10,
        }}
        to="/program-management"
      >
        <span className="button-back" style={{ whiteSpace: "nowrap" }}>
          Back to Program Management
        </span>
      </Link>
    </Grid>
  );
};

export default PendingActionWidget;
